var map = {
	"./colourboard/info-01.jpg": "c011",
	"./colourboard/info-02.jpg": "9e3e",
	"./colourboard/info-03.jpg": "f7de",
	"./colourboard/info-04.jpg": "01e9",
	"./hmr/info-01.jpg": "e6b0",
	"./hmr/info-02.jpg": "cf8b",
	"./hmr/info-03.jpg": "208f",
	"./hmr/info-04.jpg": "b213",
	"./shdf/info-01.jpg": "09f4",
	"./shdf/info-02.jpg": "77a4",
	"./shdf/info-03.jpg": "591f",
	"./shdf/info-04.jpg": "3599",
	"./thickboard/info-01.jpg": "1a85",
	"./thickboard/info-02.jpg": "ac1a",
	"./thickboard/info-03.jpg": "d0124",
	"./thickboard/info-04.jpg": "9f64",
	"./thinboard/info-01.jpg": "a7da",
	"./thinboard/info-02.jpg": "f47a",
	"./thinboard/info-03.jpg": "d06d",
	"./thinboard/info-04.jpg": "ab27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ccd";